import { gql } from '@apollo/client'
import { ANONYMOUS_ZONE_FRAGMENT } from '../fragments/AnonymousZoneFragment'

export const GET_ANONYMOUS_ZONES = gql`
  query GetAnonymousZones($input: ZonesInput) {
    anonymousZones(input: $input) {
      ...AnonymousZone
    }
  }
  ${ANONYMOUS_ZONE_FRAGMENT}
`
